export default "__VITE_ASSET__7c5db147__"